import { MutableRefObject, useCallback, useEffect, useRef } from "react"

import { s } from "../utilities/common"
import { Buttons, dimensions, keydown, keyup } from "../utilities/constants"

import { useEventBind } from "./useEventBind"

const scrollSpeed = s(200)
export const useModalScroll = (
  scrollRef: MutableRefObject<HTMLElement | null>,
) => {
  const sub = useRef<NodeJS.Timeout | undefined>(null)
  const subWheel = useRef(0)
  const scrollAmount = useRef(0)
  const scroll = useCallback(
    (increase: number) => {
      if (scrollRef.current) {
        if (scrollRef.current?.scrollHeight < dimensions.height) return
        scrollAmount.current =
          increase > 0
            ? Math.min(
                scrollRef.current?.scrollHeight - dimensions.height,
                scrollAmount.current + increase,
              )
            : Math.max(0, scrollAmount.current - scrollSpeed)
        scrollRef.current.style.transform =
          "translate3d(0, " + -Math.min(scrollAmount.current) + "px, 0)"
        scrollRef.current.style.transform =
          "translate3d(0, " + -Math.min(scrollAmount.current) + "px, 0)"
        if (subWheel.current > 0) setTimeout(() => (subWheel.current = 0), 250)
      }
    },
    [scrollRef],
  )
  const keyDown = useCallback(
    (e: KeyboardEvent) => {
      if (
        sub.current ||
        !scrollRef?.current ||
        !(e.keyCode === Buttons.Down || e.keyCode === Buttons.Up) ||
        scrollRef.current.scrollHeight < dimensions.height
      )
        return
      e.stopImmediatePropagation()
      const direction = e.keyCode === Buttons.Down ? 1 : -1
      scroll(scrollSpeed * direction)
      sub.current = setInterval(() => scroll(scrollSpeed * direction), 250)
    },
    [scrollRef],
  )

  const wheel = useCallback(
    (e: WheelEvent) => {
      e.stopImmediatePropagation()
      if (subWheel.current > 0 || !scrollRef?.current) return
      subWheel.current = scrollSpeed
      if (e.deltaY < 0) {
        scroll(-subWheel.current)
      } else if (e.deltaY > 0) {
        scroll(subWheel.current)
      }
    },
    [scrollRef],
  )

  const keyUp = useCallback(
    (e: KeyboardEvent) => {
      e.stopImmediatePropagation()
      if (sub.current) clearInterval(sub.current)
      sub.current = undefined
    },
    [scrollRef],
  )

  useEventBind(window, keydown, keyDown)
  useEventBind(window, keyup, keyUp)
  useEventBind(window, "wheel", wheel)

  useEffect(() => {
    return () => {
      if (sub.current) clearInterval(sub.current)
    }
  }, [])
}
